import { Reveal } from "@/components/Reveal";
import { Seo } from "@/components/Seo";
import { QuestionForm } from "@/components/QuestionForm";

const FAQS = [
  {
    q: "What does the one-time development fee cover?",
    a: "Design and build of your website for the page count in your package — strategy, custom responsive design, on-page SEO foundations, performance optimization and a defined number of revision rounds.",
  },
  {
    q: "Are there any costs beyond the package?",
    a: "Third-party expenses such as domain, hosting, paid plugins, premium software licences and complex integrations may add charges. We identify every one clearly before work begins — no hidden fees.",
  },
  {
    q: "Is maintenance an unlimited service?",
    a: "No. Maintenance is an ongoing subscription with a defined scope — agreed tasks, response times and a monthly development allowance. It is not an unlimited redesign or development service.",
  },
  {
    q: "Can the development fee be reduced?",
    a: "Yes — commit to an ongoing maintenance term when you launch and we reduce your one-time fee. The exact credit and its terms are shown with the commitment toggle on the packages page.",
  },
];

const faqJsonLd = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: FAQS.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
};

export default function Faq() {
  return (
    <>
      <Seo
        title="Pricing & Packages FAQ — OFFCRAFT"
        description="Straight answers about OFFCRAFT's website packages, pricing scope, third-party costs and maintenance — plus a direct line to ask your own question."
        jsonLd={faqJsonLd}
      />
      <main className="mx-auto max-w-4xl px-6 pb-24 pt-28 lg:pt-36">
        <p className="font-mono text-xs font-bold uppercase tracking-[0.3em] text-crimson">Straight answers</p>
        <h1 className="mt-6 font-display text-4xl font-extrabold leading-[1.02] tracking-tight text-ink sm:text-6xl">
          Pricing questions, <span className="text-crimson">answered.</span>
        </h1>
        <p className="mt-6 max-w-2xl text-base leading-relaxed text-ink/65">
          Everything clients ask before choosing a package — scope, third-party costs, maintenance limits and commitment credits. If your question isn't here, ask it below; it comes straight to our inbox.
        </p>

        <div className="mt-12 border-t border-ink/10">
          {FAQS.map((f, i) => (
            <Reveal key={i} delay={i * 0.05}>
              <div className="border-b border-ink/10 py-6">
                <h2 className="font-display text-lg font-bold text-ink sm:text-xl">{f.q}</h2>
                <p className="mt-2 text-sm leading-relaxed text-ink/60">{f.a}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1}>
          <div className="mt-12 border border-ink/10 bg-surface p-6 sm:p-8">
            <p className="font-mono text-[11px] font-bold uppercase tracking-[0.2em] text-crimson">Have a different question?</p>
            <h2 className="mt-2 font-display text-2xl font-bold text-ink">Ask us directly.</h2>
            <p className="mt-2 text-sm leading-relaxed text-ink/60">
              Write your own question about packages, pricing or maintenance — it comes straight to our inbox and we reply by email within a working day.
            </p>
            <QuestionForm />
          </div>
        </Reveal>
      </main>
    </>
  );
}
